import toast from "react-hot-toast";
import * as api from "../Api/index";

export const getDepartment = () => async (dispatch) => {
  try {
    const { data } = await api.getDepartment();
    dispatch({ type: "GET_ALL_DEPARTMENTS", payload: data });
  } catch (error) {}
};

export const createDepartment = (postData) => async (dispatch) => {
  let creatingId;
  try {
    creatingId = toast.loading("Creating Department....");
    const { data } = await api.createDepartment(postData);
    dispatch({ type: "CREATE_DEPARTMENT", payload: data });
    toast.remove(creatingId);
    toast.success("Department created successfully");
  } catch (error) {
    toast.remove(creatingId);
    toast.error(error.message);
  }
};

export const deleteDepartment = (id) => async (dispatch) => {
  let deletingId;
  try {
    deletingId = toast.loading("Deleting Department....");
    await api.deleteDepartment(id);
    dispatch({ type: "DELETE_DEPARTMENT", payload: id });
    toast.remove(deletingId);
    toast.success("Successfully deleted");
  } catch (error) {
    toast.remove(deletingId);
    toast.error(error.message);
  }
};

export const updateDepartment = (id, postData) => async (dispatch) => {
  let updatingId;
  try {
    toast.loading("Updating Department");
    await api.updateDepartment(id, postData);
    dispatch({ type: "UPDATE_DEPARTMENT", payload: postData });
    toast.remove(updatingId);
    toast.success("Department updated successfully");
  } catch (error) {
    toast.remove(updatingId);
    toast.error(error.message);
  }
};
